import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import { Values } from "@src/Tools/Values";
import ThemesContent from "./ThemesContent/ThemesContent";

interface IProps {
  management?: IManagementStore;
}

@inject("management")
@observer
class ManageThemes extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      await this.props.management.getThemes();
      await this.props.management.getActiveLocations();
      this.isLoading = false;
      document.title = Values.getLocalizationValue("themes");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <ThemesContent />}</div>;
  }
}

export default ManageThemes;
